/**
 * Represent the types of sources to handle in the Paste Plugin
 */
// eslint-disable-next-line etc/no-const-enum
export var KnownPasteSourceType;
(function (KnownPasteSourceType) {
    KnownPasteSourceType[KnownPasteSourceType["WordDesktop"] = 0] = "WordDesktop";
    KnownPasteSourceType[KnownPasteSourceType["ExcelDesktop"] = 1] = "ExcelDesktop";
    KnownPasteSourceType[KnownPasteSourceType["ExcelOnline"] = 2] = "ExcelOnline";
    KnownPasteSourceType[KnownPasteSourceType["PowerPointDesktop"] = 3] = "PowerPointDesktop";
    KnownPasteSourceType[KnownPasteSourceType["GoogleSheets"] = 4] = "GoogleSheets";
    KnownPasteSourceType[KnownPasteSourceType["WacComponents"] = 5] = "WacComponents";
    KnownPasteSourceType[KnownPasteSourceType["Default"] = 6] = "Default";
    KnownPasteSourceType[KnownPasteSourceType["SingleImage"] = 7] = "SingleImage";
})(KnownPasteSourceType || (KnownPasteSourceType = {}));
//# sourceMappingURL=KnownPasteSourceType.js.map